import { Action } from '@ngrx/store';
import { ServiceGroup } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len

export const ADD_DECLINED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Add Declined Service In State';
export class AddDeclinedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = ADD_DECLINED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { serviceGroup: ServiceGroup }) {}
}

export const REMOVE_DECLINED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Remove Declined Service In State';
export class RemoveDeclinedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = REMOVE_DECLINED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { id: string }) {}
}

export const CLEAR_DECLINED_SERVICE_IN_STATE = '[VEHICLE_MAINTENANCE] Clear Declined Service In State';
export class ClearDeclinedServiceInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = CLEAR_DECLINED_SERVICE_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export type DeclinedServiceAction =
  | AddDeclinedServiceInState
  | RemoveDeclinedServiceInState
  | ClearDeclinedServiceInState;
